// Mock data para o portfólio Daniel Lima
import weathernator from "@/assets/images/weathernator.png";
import riffeiOnline from "@/assets/images/riffei-online.png";
import indMetrics from "@/assets/images/indmetrics.png";
import brainLine from "@/assets/images/brainline.png";

export const developerInfo = {
  name: "Daniel Lima",
  title: "Desenvolvedor Full Stack",
  stacks: ["React", "Node.js", "TypeScript", "JavaScript", "C#"],
  description:
    "Desenvolvedor full stack especializado em criar aplicações web escaláveis e responsivas. Com experiência sólida em front-end e back-end, foco em performance, usabilidade e boas práticas de desenvolvimento. Apaixonado por transformar ideias em soluções digitais elegantes e funcionais.",
  image: "/images/developer-photo.png", // Placeholder - adicionar foto real
  // resume: "/files/resume.pdf",
};

export const specialties = [
  {
    id: 1,
    title: "Front-end",
    description: "Desenvolvimento de interfaces modernas e responsivas",
    technologies: ["React", "TypeScript", "Tailwind CSS", "Styled Components"],
    icon: "code",
  },
  {
    id: 2,
    title: "Back-end",
    description: "APIs robustas e escaláveis para aplicações complexas",
    technologies: ["Node.js", "C#", ".NET", "RESTful APIs"],
    icon: "server",
  },
  {
    id: 3,
    title: "Banco de Dados",
    description: "Modelagem e otimização de bancos relacionais e NoSQL",
    technologies: ["SQL Server", "PostgreSQL", "MongoDB", "Redis"],
    icon: "database",
  },
  {
    id: 4,
    title: "Integrações",
    description: "Conexão com serviços externos e automações",
    technologies: ["APIs REST", "WebSockets", "OAuth", "Mensageria"],
    icon: "plug",
  },
];

export const projects = [
  {
    id: 1,
    name: "Weathernator",
    description:
      "Aplicação web para monitoramento climático com insights de IA",
    technologies: ["React", "NestJs", "Python", "GO", "MongoDB"],
    image: weathernator,
    alt: "Imagem da aplicação de monitoramento climático weathernator",
    demoUrl:
      "https://github.com/danlimax/desafio-gdash-2025-02/tree/daniel-domingos-almeida-lima-desafio-weathernator",
    repoUrl:
      "https://github.com/danlimax/desafio-gdash-2025-02/tree/daniel-domingos-almeida-lima-desafio-weathernator",
    featured: true,
  },
  {
    id: 2,
    name: "Riffei Online",
    description:
      "Plataforma completa de rifas online com dashboad das informações dos sorteios",
    technologies: ["React", "Node.js", "Postgres", "Stripe"],
    image: riffeiOnline,
    alt: "Imagem de um projeto de rifas online.",
    demoUrl: "https://riffei-online.vercel.app/",
    repoUrl: "https://github.com/danlimax",
    featured: true,
  },
  {
    id: 3,
    name: "IndMetrics",
    description:
      "Calculadora para índices financeiros, exibindo os resultados dos indicadores em percentual e mostrando se a ação é um bom investimento.",
    technologies: ["Html", "Css", "BootStrap"],
    image: indMetrics,
    demoUrl: "https://indmetrics.vercel.app/calculadora.html",
    repoUrl: "https://github.com/LucasDanniel/IndMetrics",
    featured: true,
  },
  {
    id: 4,
    name: "BrainLine",
    description:
      "Plataforma para ensino gamificado de programação totalmente gratuito para iniciantes.",
    technologies: ["React", "Node.js", "TypeScript", "PostgreSQL"],
    image: brainLine,
    demoUrl: "https://brainline.lovable.app",
    repoUrl: "https://github.com/danlimax",
    featured: true,
  },
  // {
  //   id: 4,
  //   name: "API Gateway Service",
  //   description:
  //     "Gateway de APIs com autenticação, rate limiting e logging centralizado para microserviços.",
  //   technologies: ["C#", ".NET Core", "Redis", "Docker"],
  //   image: "/images/project-4.png",
  //   demoUrl: "https://demo-project-4.com",
  //   repoUrl: "https://github.com/daniellima/project-4",
  //   featured: false,
  // },
  // {
  //   id: 5,
  //   name: "Real Estate Portal",
  //   description:
  //     "Portal imobiliário com busca avançada, filtros dinâmicos e tour virtual 360°.",
  //   technologies: ["React", "Node.js", "MongoDB", "Google Maps API"],
  //   image: "/images/project-5.png",
  //   demoUrl: "https://demo-project-5.com",
  //   repoUrl: "https://github.com/daniellima/project-5",
  //   featured: false,
  // },
  // {
  //   id: 6,
  //   name: "Fitness Tracking App",
  //   description:
  //     "Aplicativo de acompanhamento fitness com planos de treino personalizados e estatísticas.",
  //   technologies: ["React Native", "Node.js", "MongoDB", "Firebase"],
  //   image: "/images/project-6.png",
  //   demoUrl: "https://demo-project-6.com",
  //   repoUrl: "https://github.com/daniellima/project-6",
  //   featured: false,
  // },
];

export const skills = [
  { name: "React", level: 95, category: "frontend" },
  { name: "TypeScript", level: 90, category: "frontend" },
  { name: "JavaScript", level: 95, category: "frontend" },
  { name: "Node.js", level: 90, category: "backend" },
  { name: "C#", level: 75, category: "backend" },
  { name: ".NET", level: 75, category: "backend" },
  { name: "SQL", level: 80, category: "database" },
  { name: "Postgres", level: 85, category: "database" },
  { name: "REST APIs", level: 90, category: "integration" },
  { name: "Git", level: 90, category: "tools" },
];

export const socialLinks = {
  github: "https://github.com/danlimax",
  linkedin: "https://www.linkedin.com/in/daniel-lima-08845717a/",
  whatsapp: "https://wa.me/5579991211209",
  email: "mailto:daniellimaa05@gmail.com",
};

// export const contactInfo = {
//   email: "daniel.lima@email.com",
//   phone: "+55 11 99999-9999",
//   location: "São Paulo, Brasil",
// };
